"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioGroup = void 0;
const react_1 = __importStar(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const lodash_1 = require("lodash");
const FormControlLabel_1 = __importDefault(require("@material-ui/core/FormControlLabel"));
const Radio_1 = __importDefault(require("@material-ui/core/Radio"));
const RadioGroup_1 = __importDefault(require("@material-ui/core/RadioGroup"));
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const radio_group_styles_1 = require("./radio-group-styles");
function RadioGroup({ source, disabled, onChange, value, valueIsId = false, idMapper = (option) => option.id, labelMapper = (option) => option.name, form, }) {
    const classes = (0, radio_group_styles_1.useStyles)();
    value = value !== null && value !== void 0 ? value : null;
    const valueToId = (0, event_callback_hook_1.useEventCallback)((value) => {
        return valueIsId ? value : idMapper(value);
    });
    const idToValue = (0, event_callback_hook_1.useEventCallback)((id) => {
        return valueIsId ? id : options.find((option) => idMapper(option) === id);
    });
    // in some cases the value is not included in the options, adds it at the end
    const options = (0, react_1.useMemo)(() => {
        if (value && !valueIsId) {
            return (0, lodash_1.uniqBy)([...source.items, value], valueToId);
        }
        else {
            return source.items;
        }
    }, [value, source, valueIsId, valueToId]);
    const handleChange = (0, event_callback_hook_1.useEventCallback)(async (e) => {
        const id = e.target.value;
        let value;
        if (id === undefined || id === '') {
            value = null;
        }
        else {
            value = idToValue(id);
            if (!valueIsId) {
                value = await source.loadDetail(value);
            }
        }
        onChange(value);
    });
    function getLocalValue(value) {
        if (value === null) {
            return '';
        }
        const optionIds = options.map((option) => idMapper(option));
        const id = valueToId(value);
        return optionIds.includes(id) ? id : '';
    }
    return (react_1.default.createElement(RadioGroup_1.default, { value: getLocalValue(value), onChange: handleChange }, options.map((option) => (react_1.default.createElement(FormControlLabel_1.default, { key: idMapper(option), disabled: disabled, value: idMapper(option), label: labelMapper(option), form: form, classes: {
            label: classes.labelLabel,
            root: classes.labelRoot,
        }, control: react_1.default.createElement(Radio_1.default, { color: "primary", className: (0, clsx_1.default)(classes.radioRoot, {
                [classes.highlightedIcon]: !disabled,
            }) }), className: classes.radioControl })))));
}
exports.RadioGroup = RadioGroup;
//# sourceMappingURL=radio-group.js.map